import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "constructor-set-box__title" };
const _hoisted_2 = { class: "constructor-set-box__content" };
const _hoisted_3 = { class: "constructor-set-box__title" };
const _hoisted_4 = { class: "constructor-set-box__summary" };
const _hoisted_5 = { class: "constructor-set-box__button" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import Sprite from "../../components/Sprite.vue";
import Price from "../../components/Price.vue";
import UserSetModal from "../user_sets/UserSetModal.vue";
import EventBus from "../../events/EventBus";
import { handleAddToCartButtonClick } from "../../components/product/add_to_cart";
import { StatusClassNames } from "../../types/StatusClassNames";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserSetConstructorApp',
    props: {
        set: { type: Object, required: true },
        mode: { type: String, default: 'constructor' },
        authorized: { type: Boolean, default: false },
        status: { type: String, default: 'create' },
        openModal: { type: Boolean, default: false },
    },
    setup(__props) {
        const props = __props;
        const modal = ref();
        const inner = ref();
        // Появляется полным, как серверная разметка, которую заменяет: если колонка уже прилипла, сжатие сыграет после.
        const entering = ref(true);
        // Высота содержимого в полном виде. Рамка виджета меняет высоту между ней и высотой сжатого вида:
        // от самого содержимого зависеть нельзя, оно в середине смены вида перестраивается. Пока колонка прилипла
        // и виджет сжат, высоту полного вида не узнать — оставляем прошлую.
        const contentHeight = new ResizeObserver(([entry]) => {
            const el = entry.target;
            if (!el.closest(`.${StatusClassNames.stuck}`)) {
                setContentHeight(el, entry.borderBoxSize[0].blockSize);
            }
        });
        function setContentHeight(el, height) {
            el.parentElement.style.setProperty('--fold-content-height', `${height}px`);
        }
        // Локальное состояние сета
        const setContent = ref([...props.set.content]);
        const setName = ref(props.set.name);
        const setUuid = ref(props.set.uuid ?? null);
        const currentStatus = ref(props.status);
        const saving = ref(false);
        // Синхронизация данных сета
        function applySetData(set) {
            if (set.content) {
                setContent.value = [...set.content];
            }
            if (set.name !== undefined) {
                setName.value = set.name;
            }
            if (set.uuid !== undefined) {
                setUuid.value = set.uuid ?? null;
            }
        }
        watch(() => props.set, (newSet) => applySetData(newSet));
        const sharedSet = computed(() => ({
            ...props.set,
            uuid: setUuid.value ?? props.set.uuid,
            name: setName.value,
            content: setContent.value
        }));
        const count = computed(() => setContent.value.length);
        const maxItems = computed(() => props.set.maxItems);
        const setFilled = computed(() => count.value === maxItems.value);
        const currentPrice = computed(() => {
            return setContent.value.reduce((sum, item) => sum + item.price, 0);
        });
        const canBuy = computed(() => setContent.value.every(item => item.available));
        async function addToCart() {
            if (!setFilled.value || !canBuy.value) {
                return;
            }
            saving.value = true;
            try {
                await handleAddToCartButtonClick({
                    type: props.mode === 'constructor' ? 'draft' : 'user_set',
                    id: setUuid.value,
                });
            }
            finally {
                saving.value = false;
            }
        }
        const handleUpdateEvent = (newData) => {
            if (newData?.set) {
                applySetData(newData.set);
            }
            if (newData?.status) {
                currentStatus.value = newData.status;
            }
        };
        function showModal() {
            if (count.value > 0) {
                modal.value?.show();
            }
        }
        onMounted(() => {
            EventBus.on('set:update', handleUpdateEvent);
            contentHeight.observe(inner.value);
            // Пока is-entering, виджет полный: высоту полного вида узнаём сейчас, даже если колонка уже прилипла.
            setContentHeight(inner.value, inner.value.offsetHeight);
            // Применяем стили полного вида уже с этой высотой: от них пойдёт переход, когда снимется is-entering.
            // Иначе высота рамки переходила бы от auto и не анимировалась.
            void inner.value.parentElement.offsetHeight;
            entering.value = false;
        });
        onUnmounted(() => {
            EventBus.off('set:update', handleUpdateEvent);
            contentHeight.disconnect();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["constructor-set-box constructor-set-box--widget", { 'constructor-set-box--filled': setFilled.value, 'is-entering': entering.value }])
                }, [
                    _createElementVNode("div", {
                        ref_key: "inner",
                        ref: inner,
                        class: "constructor-set-box__inner"
                    }, [
                        (currentStatus.value === 'create')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(setFilled.value ? 'Новый сет собран' : 'Собираем новый сет'), 1 /* TEXT */),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxItems.value, (n) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: n,
                                            class: _normalizeClass(["constructor-set-box__item", { 'is-active': n <= count.value }])
                                        }, [
                                            _createVNode(Sprite, {
                                                name: "atomizer",
                                                size: 32
                                            })
                                        ], 2 /* CLASS */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ], 64 /* STABLE_FRAGMENT */))
                            : (currentStatus.value === 'edit')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _cache[1] || (_cache[1] = _createTextVNode("\n          Редактируем сет", -1 /* CACHED */)),
                                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                        _createElementVNode("strong", null, "«" + _toDisplayString(setName.value) + "»", 1 /* TEXT */)
                                    ]),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "constructor-set-box__content" }, [
                                        _createElementVNode("img", {
                                            src: "/img/set-box.svg",
                                            width: "60",
                                            height: "44",
                                            alt: ""
                                        })
                                    ], -1 /* CACHED */))
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("strong", null, _toDisplayString(count.value) + " из " + _toDisplayString(maxItems.value), 1 /* TEXT */),
                            _cache[5] || (_cache[5] = _createTextVNode(" на сумму\n        ", -1 /* CACHED */)),
                            _createElementVNode("strong", null, [
                                _createVNode(Price, { amount: currentPrice.value }, null, 8 /* PROPS */, ["amount"])
                            ])
                        ]),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                onClick: showModal,
                                type: "button",
                                class: "btn btn--2 btn--s btn--black wide",
                                disabled: count.value === 0
                            }, _toDisplayString(count.value > 0 ? 'Состав сета' : 'Сет пуст'), 9 /* TEXT, PROPS */, _hoisted_6),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            (setFilled.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn--1 btn--s btn--black wide constructor-set-box__cart",
                                    style: { "margin-top": "8px" },
                                    disabled: saving.value || !canBuy.value,
                                    onClick: addToCart
                                }, _toDisplayString(saving.value ? 'Добавление...' : 'В корзину'), 9 /* TEXT, PROPS */, _hoisted_7))
                                : _createCommentVNode("v-if", true)
                        ])
                    ], 512 /* NEED_PATCH */)
                ], 2 /* CLASS */),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _createVNode(UserSetModal, {
                    ref_key: "modal",
                    ref: modal,
                    set: sharedSet.value,
                    mode: __props.mode,
                    authorized: __props.authorized,
                    open: __props.openModal
                }, null, 8 /* PROPS */, ["set", "mode", "authorized", "open"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
